// extracted by css-extract-rspack-plugin
export default {"warningBox":"ContractTargetWarnings__warningBox--dKGDF","warningBoxText":"ContractTargetWarnings__warningBoxText--nOuhW","closeButton":"ContractTargetWarnings__closeButton--GdVWc"};